export default "__VITE_ASSET__uQvJq61D__"